module.exports = __webpack_public_path__ + "img/10.5a4b552.png";